export default {
  'layout.scenario_overview_layout.subnav_link.status_checks.text':
    'Health Checks'
}
